import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackOfficeLayout from '../../components/backoffice/BackOfficeLayout';
import { useAuth } from '../../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { UserPlus } from 'lucide-react';
import { toast } from '../../lib/safeToast';
import { getApiErrorMessage } from '../../lib/utils';

const BackOfficeMerchantAdd = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !name.trim()) {
      toast.error('Name and email are required');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/users', { name, email, role: 'merchant_admin' });
      const temp = res.data?.data?.temp_password;
      toast.success(temp ? `User created. Temporary password: ${temp}` : 'Merchant user created.');
      navigate('/backoffice/merchants');
    } catch (err) {
      toast.error(getApiErrorMessage(err.response?.data?.detail, 'Failed to create user'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <BackOfficeLayout>
      <div className="max-w-xl space-y-6">
        <div className="pb-4">
          <h1 className="text-2xl font-bold text-[#073B2E] flex items-center gap-2">
            <UserPlus className="w-7 h-7 text-[#0B6445]" />
            Add New Merchant
          </h1>
          <p className="text-[#0E1B16]/70 mt-2">Create a new merchant (first user of a new organisation, Merchant Admin role).</p>
        </div>
        <Card className="border-[#DCE4E0] shadow-sm">
          <CardHeader>
            <CardTitle className="text-base">Merchant details</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="name">Legal / Display name</Label>
                <Input id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Acme Pty Ltd" className="mt-1" />
              </div>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="merchant@example.com" className="mt-1" />
              </div>
              <div className="flex gap-2 pt-2">
                <Button type="submit" className="bg-[#0B6445] hover:bg-[#095b3d]" disabled={loading}>
                  {loading ? 'Creating…' : 'Create merchant'}
                </Button>
                <Button type="button" variant="outline" onClick={() => navigate('/backoffice/merchants')} className="border-slate-300 text-slate-700 hover:bg-slate-100 hover:text-slate-900">Cancel</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </BackOfficeLayout>
  );
};

export default BackOfficeMerchantAdd;
